<template>
  <div class="closeModalBtn" v-if="isPopFrame" @click="closeModalFunc(null)"><i class="iconfont yyq-icon-close_1"></i></div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'closeModalBtn',
  data () {
    return {}
  },
  methods: {
    closeModalFunc (msg) {
      window.parent.postMessage(msg || {
        eventType: 'sendMessage',
        data: {
          token: '', // 登录成功后token
          iframeState: 'hide' // iframe状态
        }
      }, '*')
    },
    sendMsgOfSuccess (token) {
      const msg = {
        eventType: 'sendMessage',
        data: {
          token, // 登录成功后token
          iframeState: 'hide' // iframe状态
        }
      }
      this.closeModalFunc(msg)
    }
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame
    })
  }
}
</script>

<style scoped lang="scss">
.closeModalBtn{
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  i{
    font-size: 16px;
    color: #999999;
  }
}
</style>
